























































































import {Vue, Component} from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {i18nInObjectList} from '@/utils/i18n';
import {getToday, addMonth} from '@/utils/dateUtils';
import {GetCouponsRequest, PromotionSearchKeywordType, PromotionCouponType, PromotionIssueType} from 'supporter';

@Component({
  components: {
    PeriodDateCalendar,
    ItemTable
  }
})
export default class PopSearchCoupon extends Vue {
  private contentBottomOption = {
    autoHeight: false,
    showTopcontent: true,
    nonDataBodyHeight: 130,
    haveDataBodyHeight: 130,
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    havePageSizeBtn: true,
    pageSize: '10',
    pageSizes: [
      {
        value: '10',
        name: 'COMMON_PAGE_SIZE_10'
      },
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
    ],
  };
  private coupons: any[] = [];
  private totalCount: number = 0;
  private searchTypeArr = [
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_TYPE_ALL',
      value: 'ALL'
    },
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_TYPE_NAME',
      value: 'COUPON_NAME'
    },
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_TYPE_NO',
      value: 'COUPON_NO'
    }
  ];
  private searchDateTypeArr = [
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_DATE_TYPE_START',
      value: 'ISSUE_START_YMD'
    },
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_DATE_TYPE_END',
      value: 'ISSUE_END_YMD'
    },
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_DATE_TYPE_REGISTER',
      value: 'REGISTER_YMD'
    }
  ];
  private couponTypeArr = [
    {
      label: 'EVENT_SEARCH_COUPON_SEARCH_TYPE_ALL',
      value: ''
    },
    {
      label: 'EVENT_SEARCH_COUPON_COUPON_TYPE_PRODUCT',
      value: 'PRODUCT'
    },
    {
      label: 'EVENT_SEARCH_COUPON_COUPON_TYPE_CART',
      value: 'CART'
    }
  ];
  private statusTypeArr = [
    {
      label: 'EVENT_SEARCH_COUPON_STATUS_TYPE_READY',
      value: 'ISSUE_READY'
    },
    {
      label: 'EVENT_SEARCH_COUPON_STATUS_TYPE_ING',
      value: 'ISSUE_ING'
    },
    {
      label: 'EVENT_SEARCH_COUPON_STATUS_TYPE_STOP',
      value: 'ISSUE_STOP'
    },
    {
      label: 'EVENT_SEARCH_COUPON_STATUS_TYPE_END',
      value: 'ISSUE_END'
    }
  ];
  private issueTypeArr = [
    {
      label: 'EVENT_SEARCH_COUPON_ISSUE_TYPE_DOWNLOAD',
      value: 'DOWNLOAD'
    },
    {
      label: 'EVENT_SEARCH_COUPON_ISSUE_TYPE_DESIGNATE',
      value: 'CODE_DESIGNATE'
    },
    {
      label: 'EVENT_SEARCH_COUPON_ISSUE_TYPE_RANDOM',
      value: 'CODE_RANDOM'
    },
    {
      label: 'EVENT_SEARCH_COUPON_ISSUE_TYPE_INSERT',
      value: 'INSERT'
    },
    {
      label: 'EVENT_SEARCH_COUPON_ISSUE_TYPE_ADMIN_ONLY',
      value: 'CODE_DESIGNATE_ADMIN_ONLY'
    }
  ];
  private theForm: GetCouponsRequest = {
    params: {
      page: 1,
      size: 10,
      mallNos: '',
      searchDateType: 'ISSUE_START_YMD',
      startYmd: '',
      endYmd: '',
      searchKeywordType: 'ALL' as PromotionSearchKeywordType,
      keyword: '',
      couponType: '' as PromotionCouponType,
      issueType: 'INSERT'
    }
  };
  private startYmdt: string = addMonth(new Date(), -3);
  private endYmdt: string = getToday();
  private periodOption = {
    periodTypes: ['td', '1w', '1m', '3m', '6m']
  };

  private gridProps = {
    options: {
      pageOptions: {
        visiblePages: 10,
        perPage: 10,
        page: 1,
        totalCount: 0
      },
      header: {
        height: 33
      },
      columnOptions: {
        minWidth: 50
      },
      minRowHeight: 31,
      rowHeight: 31,
      minBodyHeight: 130,
      bodyHeight: 130,
      isInitialRequest: true,
      useClientSort: false,
    },
    columns: [
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_ONE',
        align: 'center',
        minWidth: 50,
        formatter: (data: any) => {
          return `<input type="radio" value="${data.row.theIndex}" name="table_radio" id="table_radio_${data.row.no}">`;
        }
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_TWO',
        name: 'no',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_THREE',
        name: 'mallName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_FOUR',
        name: 'couponStatusTypeLabel',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_FIVE',
        name: 'couponName',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_SIX',
        name: 'couponTypeLabel',
        align: 'center',
        minWidth: 120
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_SEVEN',
        name: 'issueTypeLabel',
        align: 'center',
        minWidth: 120
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_EIGHT',
        name: 'issueLimitCnt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_NIGH',
        name: 'totalIssueCnt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_TEN',
        name: 'totalUseCnt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_ELEVEN',
        name: 'issueStartYmdt',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_TWELVE',
        name: 'issueEndYmdt',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_THIRTEEN',
        name: 'registerAdminName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_FOURTEEN',
        name: 'registerYmdt',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_FIFTEEN',
        name: 'updateAdminName',
        align: 'center',
        minWidth: 80,
        formatter: (data) => {
          if (data.row.updateAdminName) {
            return data.row.updateAdminName;
          } else {
            return '-';
          }
        }
      },
      {
        header: 'EVENT_SEARCH_COUPON_TABLE_HEADER_SIXTEEN',
        name: 'updateYmdt',
        align: 'center',
        minWidth: 140
      }
    ]
  };
  private getCouponsList() {
    this.theForm.params.mallNos = this.$route.query.mallNo as string;
    this.theForm.params.startYmd = this.startYmdt;
    this.theForm.params.endYmd = this.endYmdt;
    this.$api.getCoupons(this.theForm).then((res) => {
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.page = this.theForm.params.page;
      this.gridProps.options.pageOptions.perPage = this.theForm.params.size;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;

      res.data.contents.map((item, index) => {
        Vue.set(item, 'theIndex', index);
        Vue.set(item, 'couponStatusTypeLabel', this.$t(this.statusTypeArr.filter((temp) => temp.value === item.couponStatusType)[0].label));
        Vue.set(item, 'couponTypeLabel', this.$t(this.couponTypeArr.filter((temp) => temp.value === item.couponType)[0].label));
        Vue.set(item, 'issueTypeLabel', this.$t(this.issueTypeArr.filter((temp) => temp.value === item.issueType)[0].label));
      });
      this.coupons = [...res.data.contents];
    });
  }
  private reset() {
    this.theForm = {
      params: {
        page: 1,
        size: 10,
        mallNos: '',
        searchDateType: 'ISSUE_START_YMD',
        startYmd: '',
        endYmd: '',
        searchKeywordType: 'ALL' as PromotionSearchKeywordType,
        keyword: '',
        couponType: '' as PromotionCouponType,
        issueType: 'INSERT'
      }
    };
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('3m');
  }
  private pageChangeSearch(page: number = 1, size?: number) {
    if (size) {
      this.theForm.params.size = size;
    }
    Object.assign(this.theForm.params, {page, pageSize: this.theForm.params.size});
    this.getCouponsList();
  }
  private submit() {
    let theSelectIndex = $('input[name="table_radio"]:checked').val();

    if (!theSelectIndex) {
      alert(this.$t('EVENT_SEARCH_COUPON_ERROR_SELECT_COUPON'));
    } else {
      let theCoupons = this.coupons[Number(theSelectIndex)];
      let selectedCouponNos: any = $(opener.document)
        .find('input[name=couponNo]')
        .map((i, ele) => parseInt($(ele).val() as string))
        .get();
      if (selectedCouponNos.includes(theCoupons.no)) {
        alert(this.$t('EVENT_SEARCH_COUPON_ERROR_COUPON_DUPLICATE'));
        return;
      }

      if (this.$route.query.issueType !== 'INSERT' && theCoupons.couponStatusTypeLabel === '발급중지') {
        alert(this.$t('EVENT_SEARCH_COUPON_ERROR_COUPON_CANNOT_SELECTED'));
        return;
      }
      let coupon = {
        no: theCoupons.no,
        issueCnt: theCoupons.issueLimitCnt - theCoupons.totalIssueCnt,
        issueStartYmdt: theCoupons.issueStartYmdt,
        issueEndYmdt: theCoupons.issueEndYmdt,
        couponRowIndex: this.$route.query.couponRowIndex,
        couponStatusTypeLabel: theCoupons.couponStatusTypeLabel,
        issueLimitCnt: theCoupons.issueLimitCnt,
        totalIssueCnt: theCoupons.totalIssueCnt,
        couponName: theCoupons.couponName
      };
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(coupon)});`);
      self.close();
    }
  }
  private cancelBtnClick() {
    self.close();
  }
  private created() {
    if (this.$route?.query?.issueType) {
      this.theForm.params.issueType = this.$route.query.issueType as PromotionIssueType;
      this.theForm.params.exceptChannelTypeCoupon = this.$route.query.exceptChannelTypeCoupon === 'true';
    }

    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted() {
    this.pageChangeSearch(1);
  }
}
